import React, { useCallback } from 'react';

import { observer } from 'mobx-react';
import { Button } from '@bringg/react-components';
import { useHistory } from 'react-router-dom';
import { useRoutesMonitoringTranslations } from '@bringg-frontend/monitoring';

import useRouteMonitoringStore from '../stores/helpers/use-route-monitoring-store';
import RoutesFilter from './routes-filter';
import RefreshViewButton from './action-buttons/refresh-view-button';
import DocumentationLinkButton from './action-buttons/documentation-link-button';
import { useStores } from 'bringg-web/recipes';
import { hasFeatureFlag } from 'bringg-web/utils/feature-flags';
import FilterButton from '../../shared/components/filter-button/filter-button';

import styles from './top-section.module.scss';

type TopSectionProps = {
	showFilters: boolean;
	onToggleFilterDisplay(shouldShow: boolean): void;
};

const TopSection = ({ onToggleFilterDisplay, showFilters }: TopSectionProps) => {
	const { goToOrderExplorer } = useRoutesMonitoringTranslations();
	const history = useHistory();
	const {
		usersStore: { currentUser }
	} = useStores();

	const { routesMonitoringStore } = useRouteMonitoringStore();
	const filterObjectCount = Object.keys(routesMonitoringStore.filterQuery || {}).length;

	const goToOrderExplorerBoard = useCallback(() => {
		history.push({
			pathname: '/order-details'
		});
	}, [history]);

	const hasOrderExplorer = hasFeatureFlag(currentUser, 'enable_order_explorer');

	return (
		<div className={styles.topSection}>
			<div className={styles.upperSection}>
				<div className={styles.leftContainer}>
					<DocumentationLinkButton />
					{hasOrderExplorer && (
						<Button onClick={goToOrderExplorerBoard} type="link">
							{goToOrderExplorer}
						</Button>
					)}
				</div>
				<FilterButton
					onClick={() => {
						onToggleFilterDisplay(!showFilters);
					}}
					filterObjectCount={filterObjectCount}
				/>
				<RefreshViewButton />
			</div>
			<div className={showFilters ? styles.showFilters : styles.hideFilters}>
				<RoutesFilter />
			</div>
		</div>
	);
};

export default observer(TopSection);
